module.exports = __webpack_public_path__ + "static/media/chicureo.ec6d6611.jpg";